import { render, staticRenderFns } from "./not_authorized.vue?vue&type=template&id=1bed8772&"
import script from "./not_authorized.vue?vue&type=script&lang=js&"
export * from "./not_authorized.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports